import {
  VALUABLE_ABOUT,
  VALUABLE_PRICE,
} from "Components/Features/CheckPrice/Products/RiskProducts/Valuables/valuablesConstants";

import { mapInjuriesToForm } from "Store/priceCalculation/productMappers/common/injuriesMapper";

export function mapFromCommerceValuables(data: any): any {
  return {
    [VALUABLE_ABOUT.id]: {
      product: data.valuableType,

      type: data.brand,
      brand_and_model: data.model,
      serialnumber: data.serialNumber,
      year: data.yearOfManufacture,

      description: data.description,
      coverage_amount: data.coverageAmount,

      ...mapInjuriesToForm(data.damageCountRecentYears, data.yearOfLastDamage),
    },
    [VALUABLE_PRICE.id]: {
      coverage_amount: data.coverageAmount,
    },
  };
}
